import { OfferKEKForm } from "components/forms";
import { useEffect } from "react";
import { useFormik } from "formik";
import StepFooter from "./step-footer";
import { validationSchemaKEKUpdate } from "./validation";

type Props = {
    handleNext: (_values: any) => void;
    handlePrevious: () => void;
    handleCancel: () => void;
    initialValues: any;
    isFirstStep?: boolean;
};

const OfferDetailsKEKForm = ({
    handleCancel,
    handleNext,
    initialValues,
    handlePrevious,
    isFirstStep = true,
}: Props) => {
    const form = useFormik<any>({
        initialValues,
        validationSchema: validationSchemaKEKUpdate,
        onSubmit: (values) => {
            handleNext(values);
        },
        onReset: () => {
            handleCancel();
        },
    });

    useEffect(() => {
        form.setValues(initialValues);
    }, [initialValues]);

    const handleNextClick = async () => {
        const errors = await form.validateForm();
        form.setTouched(
            Object.keys(form.values).reduce(
                (acc, key) => ({ ...acc, [key]: true }),
                {},
            ),
        );
        if (Object.keys(errors).length > 0) {
            return;
        }
        handleNext(form.values);
    };

    return (
        <div className="flex-1 flex flex-col overflow-hidden">
            <form
                onSubmit={form.handleSubmit}
                className="space-y-6 divide-y divide-gray-200 overflow-y-auto flex-1">
                <div className="p-6">
                    <OfferKEKForm form={form} />
                </div>
            </form>
            <StepFooter
                onNext={handleNextClick}
                onCancel={form.resetForm}
                onPrevious={handlePrevious}
                showPrevious={!isFirstStep}
            />
        </div>
    );
};

export default OfferDetailsKEKForm;
